export default __webpack_public_path__ + "static/media/s6.46b99dfc.png";